import { ascending, group, index } from 'd3'

export function makeRowsByAllAccounts (context) {
  const rows = groupValuesByRow(context)

  const includedRows = includeOnlyVisibleRows(rows, context)

  // Sort
  includedRows.sort(function (r1, r2) {
    return ascending(r1.chartOfAccount?.code, r2.chartOfAccount?.code)
  })

  return includedRows
}

function includeOnlyVisibleRows (rows, context) {
  return rows

  // const monthsArray = makeMonthSeries(context)

  // const includedRows = []

  // rows?.forEach(function (row) {
  //   let isRowToInclude = false

  //   monthsArray?.forEach(function (targetMonth) {
  //     const cellValue = valueMaker(row, targetMonth, context)
  //     if (cellValue) isRowToInclude = true
  //   })

  //   if (isRowToInclude) includedRows.push(row)
  // })

  // return includedRows
}

/**
 *
 * @param {*} context
 * @returns
 */
function groupValuesByRow (context) {
  console.log('groupValuesByRow', context)

  // Identify target chart of accounts
  const chartOfAccountsData = context?.chartOfAccounts
  const valuesArray = context?.convertedValues
  const accountTypesMap = index(context?.accountTypes, d => d.accountType)
  console.log('accountTypesMap', accountTypesMap)

  const targetChartOfAccounts = chartOfAccountsData?.filter(d => d.statement === context.statementType)
  const targetChartOfAccountsIds = targetChartOfAccounts.map(d => d.id)
  // console.log('targetChartOfAccounts', targetChartOfAccounts)

  const mapOfChartOfAccounts = index(chartOfAccountsData, d => d.id)
  // console.log('mapOfChartOfAccounts', mapOfChartOfAccounts)

  // Filter monthly values by target chart of accounts
  const filteredValues = valuesArray?.filter(function (d) {
    if (!targetChartOfAccountsIds.includes(d.accounting_chart_of_account_id)) return false

    const chartOfAccount = mapOfChartOfAccounts.get(d.accounting_chart_of_account_id)

    // Do not show the System Account Retained Earnings
    // May 2025: actually DO SHOW THEM: because they are needed for the Balance Sheet
    // if (chartOfAccount.system_account === 'RETAINEDEARNINGS') return false

    // Do not show the Earnings computed values in PnL
    if (chartOfAccount.id === 'earnings_pnl') return false

    return true
  })
  // console.log('filteredValues', filteredValues)

  // Group by chart of account
  const mapByChartOfAccount = group(filteredValues, d => d.accounting_chart_of_account_id)
  // console.log('mapByChartOfAccount', mapByChartOfAccount)

  // Make rows: turn map into array
  // TODO: compute stats: total, month with values, ...
  const rows = Array.from(mapByChartOfAccount.entries(), function ([key, value]) {
    const thisChartOfAccount = mapOfChartOfAccounts.get(key)

    const originChartOfAccountIds = value.map(d => d.originValues?.[0]?.originValue?.accounting_chart_of_account_id)

    return {
      id: key,
      key,
      values: value,

      originChartOfAccountIds: Array.from(new Set(originChartOfAccountIds)),

      chartOfAccount: thisChartOfAccount,
      context: {
        chartOfAccounts: [thisChartOfAccount]
      },
      accountType: accountTypesMap.get(thisChartOfAccount?.xero_type)
    }
  })
  console.log('rows', rows)

  return rows
}
